import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || '/api';

export const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: false,
  timeout: 20000,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const normalized = new Error('Request failed');
    normalized.status = error.response?.status || 0;
    normalized.data = error.response?.data || null;
    return Promise.reject(normalized);
  }
);

export async function getIdeas() {
  const res = await api.get('/ideas/');
  return res.data;
}

export async function getIdeaCompetitors(ideaId) {
  const res = await api.get(`/competitors/idea/${ideaId}`);
  return res.data;
}

export async function getIdeaById(id) {
  const res = await api.get(`/ideas/${id}`);
  return res.data;
}


